(function (Translator) {
    // fr
    Translator.add("address", "Adresse:", "PayseraMapBundle", "fr");
    Translator.add("friday", "Vendredi", "PayseraMapBundle", "fr");
    Translator.add("monday", "Lundi", "PayseraMapBundle", "fr");
    Translator.add("no_results", "Aucun r\u00e9sultat trouv\u00e9", "PayseraMapBundle", "fr");
    Translator.add("saturday", "Samedi", "PayseraMapBundle", "fr");
    Translator.add("search_placeholder", "Entrez un fragmet", "PayseraMapBundle", "fr");
    Translator.add("service.cash_in", "D\u00e9p\u00f4t", "PayseraMapBundle", "fr");
    Translator.add("service.cash_out", "Retrait", "PayseraMapBundle", "fr");
    Translator.add("service.identification", "Identification", "PayseraMapBundle", "fr");
    Translator.add("service.pay", "Paiements", "PayseraMapBundle", "fr");
    Translator.add("services", "Services:", "PayseraMapBundle", "fr");
    Translator.add("sunday", "Dimanche", "PayseraMapBundle", "fr");
    Translator.add("thursday", "Jeudi", "PayseraMapBundle", "fr");
    Translator.add("tuesday", "Mardi", "PayseraMapBundle", "fr");
    Translator.add("wednesday", "Mercredi", "PayseraMapBundle", "fr");
    Translator.add("working_hours", "Heures de travail:", "PayseraMapBundle", "fr");
})(Translator);
